export enum ChasubleBodyType {
  PlainWithSleeve = 'plain_with_sleeve',
  WithSleeveEmbroidery = 'with_sleeve_embroidery',
  WithoutSleeve = 'without_sleeve',
}
